<template>
    <v-container fluid fill-height>
      <v-layout>
        <v-flex xs12 sm12 md12>
          <v-card :loading="loading">
            <v-toolbar color="#f8f9fb" elevation="0">
              <v-toolbar-title>{{ feedbacks.title }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
  
            <v-card-text class="#f4f5f7">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <ckeditor
                        :editor="editor"
                        v-model="editorData"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-btn color="secondary" dark class="px-8 ml-2"   @click="saveData">Save</v-btn>
              <v-btn
                type="button"
                class="btn btn-primary ml-3"
                @click="openInNewWindow"
              >
                View
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  
  <script>
  import { mapMutations } from "vuex";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  
  export default {
    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {},
        feedbacks: [],
        loading: false,
      };
    },
  
    methods: {
      ...mapMutations("alert", ["setAlert"]),
      getData() {
        let _self = this;
  
        _self.$axios
          .get("superadmin/cms?identifier=terms_conditions")
          .then((response) => {
            console.log("API Response:", response.data[0]);
            _self.feedbacks = response.data[0];
            _self.editorData = _self.feedbacks.content;
            console.log("Editor Data:", _self.editorData);
          });
      },
      openInNewWindow() {
        console.log("Opening new window...");
        const newWindow = window.open("/ismartsociety/ismartsociety_front/#/term-condition", "_blank");
        if (newWindow) {
          newWindow.focus();
        }
      },
      saveData() {
        let _self = this;
        const data = { content: _self.editorData };
  
        _self.$axios.put("superadmin/cms?identifier=terms_conditions", data).then((response) => {
          let data = response.data;
  
          if (data.status) {
            this.getData();
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
      },
    },
  
    mounted() {
      this.getData();
    },
  };
  </script>
  